import React from "react";
import "../styles/Blog.css";

import DigiatlTransformation_img from '../assets/Digital_Transformation.webp';
import Innovation_img from '../assets/Innovation.jpg';
import Community_img from '../assets/Community.jpg';

const Blog = () => {
  return (
    <section className="insights" id="blog">
      <h2 data-aos="fade-up">Insights & Blog</h2>
      <p className="insights-subtitle" data-aos="fade-up" data-aos-delay="200">
        Explore stories, case studies, and ideas shaping the future of businesses,
        communities, and technology.
      </p>
      <div className="insights-grid">

        {/* Blog Card 1 */}
        <div className="insight-card" data-aos="fade-up" data-aos-delay="300">
          <div className="insight-image">
            <img src={DigiatlTransformation_img} alt="Digital Transformation" />
            <span className="category">Technology</span>
          </div>
          <div className="insight-content">
            <h3>Future of Digital Transformation</h3>
            <p>How businesses can adapt and grow in the fast-changing digital era with innovative strategies.</p>
            <a href="#hero" className="read-more">Read More →</a>
          </div>
        </div>

        {/* Blog Card 2 */}
        <div className="insight-card" data-aos="fade-up" data-aos-delay="500">
          <div className="insight-image">
            <img src={Innovation_img} alt="Innovation" />
            <span className="category">Innovation</span>
          </div>
          <div className="insight-content">
            <h3>Innovation that Empowers</h3>
            <p>Case studies on how VPPL drives community and business success with impactful solutions.</p>
            <a href="#hero" className="read-more">Read More →</a>
          </div>
        </div>

        {/* Blog Card 3 */}
        <div className="insight-card" data-aos="fade-up" data-aos-delay="700">
          <div className="insight-image">
            <img src={Community_img} alt="Community" />
            <span className="category">Community</span>
          </div>
          <div className="insight-content">
            <h3>Strengthening Communities</h3>
            <p>Discover how partnerships and engagement programs are building stronger connections.</p>
            <a href="#hero" className="read-more">Read More →</a>
          </div>
        </div>

      </div>
    </section>
  );
};

export default Blog;